export default __webpack_public_path__ + "static/media/DNo.22-0.bc59e52d.jpg";